import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DataTable from ".";
import { useTranslation } from "../../hooks/translation.hook";
import { translateRelation } from "../../../../utils/translation";

export interface DatatableModalProps {
  open: boolean;
  callbackOnCancel: () => void;
  reportStructure: Array<any>;
  modalData: ModalDataProps;
  ID_RELATORIO?: number;
  relations?: Array<any>;
  fieldRelations?: Array<any>;
}

export interface ModalDataProps {
  title: string;
  data: [{}];
  fieldKey?: string;
}

export default function DatatableModal({
  open,
  callbackOnCancel,
  modalData,
  reportStructure,
  ID_RELATORIO,
  relations = [],
  fieldRelations = [],
}: DatatableModalProps) {
  const { translations, translationsFields } = useTranslation();

  const tf = (translationsFields as unknown) as Record<string, string> | undefined;
  const modalTitle = modalData?.title
    ? (translations && translateRelation(modalData.title, translations))
      || (tf?.[modalData.title] && typeof tf[modalData.title] === 'string' ? tf[modalData.title] : null)
      || modalData.title
    : '';

  return (
    <Dialog 
      open={open} 
      aria-labelledby="datatable-dialog-title" 
      aria-describedby="datatable-dialog-description"
      maxWidth='lg'
      fullWidth={true}
    >
      <DialogContent>
        {modalData?.data?.length > 0 &&
          <DataTable
            dataRaw={modalData.data}
            data={modalData.data}
            reportStructure={reportStructure}
            ID_RELATORIO={ID_RELATORIO ?? 0}
            relations={relations}
            fieldRelations={fieldRelations}
            preferOriginAlias={modalData.fieldKey}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            loading={false}
          />
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={() => callbackOnCancel()}>Voltar</Button>
      </DialogActions>
    </Dialog>
  )
}